import { useState, useEffect } from 'react';
import { reportApi } from '../../api/report.api';
import { PageHeader, Skeleton, EmptyState, Badge } from '../../components/ui/index';
import { formatDate } from '../../utils/persianNumber';
import { useAutoRefresh } from '../../hooks/useAutoRefresh';
import { Clock } from '@phosphor-icons/react';

// The backend (get_activation_history) has existed for a while, but this
// page/route never did - the sidebar menu item ("Activation History")
// linked to a non-existent path.
export default function ActivationHistoryPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = (showSpinner = true) => {
    if (showSpinner) setLoading(true);
    return reportApi.getActivationHistory()
      .then((res) => setRows(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);
  useAutoRefresh(() => load(false));

  return (
    <div className="fade-in">
      <PageHeader title="تاریخچه فعال‌سازی" subtitle={`${rows.length} رویداد`} />
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[1, 2, 3].map((k) => <Skeleton key={k} h={56} radius={12} />)}
        </div>
      ) : rows.length === 0 ? (
        <EmptyState icon={<Clock size={44} weight="regular" />} title="رویدادی ثبت نشده است" />
      ) : (
        <div style={{ background: '#fff', borderRadius: 14, border: '1px solid rgba(35,58,122,0.1)', overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 2fr', padding: '12px 20px', background: '#f8faff', borderBottom: '1px solid #e2e8f0', fontSize: 12, fontWeight: 700, color: '#64748b' }}>
            <span>کاربر/کارمند</span><span>نوع</span><span>وضعیت</span><span>تاریخ</span><span>توضیحات</span>
          </div>
          {rows.map((r, i) => (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 2fr', padding: '13px 20px', borderBottom: '1px solid #f1f5f9', fontSize: 13, color: '#334155', background: i % 2 === 0 ? '#fff' : '#fafbff' }}>
              <span>{r.username}</span>
              <span>{r.type === 'employee' ? 'کارمند' : 'کاربر'}</span>
              <span><Badge variant={r.active ? 'green' : 'gray'}>{r.active ? 'فعال شد' : 'غیرفعال شد'}</Badge></span>
              <span>{formatDate(r.datetime)}</span>
              <span style={{ color: '#64748b' }}>{r.description || '—'}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
